<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/evaluator/maintenance/${inputs.id}`
            : `/evaluator/maintenance`
        "
      >
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>NÚMERO DE CÉDULA</label>
              <app-input
                type="text"
                v-model="inputs.taxid"
                placeholder="Ingrese el numero de CI o RUC"
                :required="true"
                @keyup="onKeyUpTaxid"
              />
              <small v-if="counter > 13" class="text-danger">RUC máximo 13 dígitos</small>
            </div>
          </div>
          <div class="col-md-6" v-if="nickname && inputs.user">
            <div class="form-group">
              <label>Usuario</label>
              <app-input
                type="text"
                v-model="inputs.user.username"
                :disabled="true"
              />
            </div>
          </div>
        </div>

        <div class="row" v-if="show && !inputs.user_id && !inputs.id">
          <div class="col-md-6">
            <div class="form-group">
              <label>Usuario</label>
              <app-input
                type="text"
                v-model="inputs.username"
                placeholder="Ingrese el nombre"
                :required="true"
                @keyup="onKeyUpUsername"
              />
              <span class="text-danger" v-if="!uniqueUsername"
                >Nombre de usuario registrado</span
              >
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Contraseña</label>
              <app-input
                type="password"
                v-model="inputs.password"
                placeholder="******"
                :required="true"
              />
            </div>
          </div>
        </div>

        <div class="row" v-if="show">
          <div class="col-md-6">
            <div class="form-group">
              <label>Nombre(s)</label>
              <app-input
                type="text"
                v-model="inputs.first_name"
                placeholder="Ingrese el nombre"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Apellido(s)</label>
              <app-input
                type="text"
                v-model="inputs.last_name"
                placeholder="Ingrese el apellido"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Telefono</label>
              <app-input
                type="tel-input"
                v-model="inputs.phone"
                placeholder="Ingrese el telefono"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Correo</label>
              <app-input
                type="email"
                v-model="inputs.email"
                placeholder="Ingrese el correo"
                :required="true"
                @keyup="onKeyUpEmail"
              />
              <span class="text-danger" v-if="!uniqueEmail"
                >Correo registrado</span
              >
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>País</label>
              <app-input
                type="select"
                v-model="inputs.country_id"
                :list="[
                  { id: '', value: this.$t('select_option') },
                  ...this.$store.state.common.countries,
                ]"
                :required="true"
              />
            </div>
          </div>

          <div
            class="col-md-6"
            v-if="inputs.country_id && provinceList.length <= 1"
          >
            <div class="form-group">
              <label>Ciudad</label>
              <app-input
                type="text"
                v-model="inputs.city"
                placeholder="Ingrese la ciudad"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="provinceList.length > 1">
            <div class="form-group">
              <label>Provincia</label>
              <app-input
                type="select"
                v-model="inputs.province_id"
                :list="[
                  { id: '', value: this.$t('select_option') },
                  ...provinceList,
                ]"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="provinceList.length > 1">
            <div class="form-group">
              <label>Ciudad</label>
              <app-input
                type="select"
                v-model="inputs.canton_id"
                :list="[
                  { id: '', value: this.$t('select_option') },
                  ...cantonList,
                ]"
                :required="true"
                placeholder="Ingrese la ciudad"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Evaluador Externo / Interno</label>
              <app-input
                  type="select"
                  v-model="inputs.scope"
                  :required="true"
                  :list="scope"
              />
            </div>
          </div>


        </div>

        <div class="row" v-if="show">
          <!-- <div class="col-md-6">
            <div class="form-group">
              <label>Codigo</label>
              <app-input
                type="text"
                v-model="inputs.code"
                placeholder="Ingrese el codigo"
                :required="true"
              />
            </div>
          </div> -->

          <!-- <div class="col-md-6">
            <div class="form-group">
              <label>Funcion</label>
              <app-input
                type="select"
                v-model="inputs.evaluator_type_id"
                :required="true"
                :list="evaluatorType"
              />
            </div>
          </div> -->



          <div class="col-md-6">
            <div class="form-group">
              <label>Institucion</label>
              <app-input
                type="text"
                v-model="inputs.institution"
                placeholder="Ingrese la institucion"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Tipo de Institucion</label>
              <app-input
                type="select"
                v-model="inputs.type_institution"
                :list="typeInstitution"
              />
            </div>
          </div>
        </div>

        <div class="row" v-if="show">
          <!-- <div class="col-md-6">
            <div class="form-group">
              <label> Area </label>
              <app-input
                type="select"
                v-model="inputs.area_id"
                :list="accreditationAreaList"
                v-on:change="onChangeAccreditationArea"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label> Actividad </label>
              <app-input
                type="select"
                v-model="inputs.activity_id"
                :list="accreditationActivityLists"
              />
            </div>
          </div> -->
        </div>




        <div class="row" v-if="show">
          <div class="col-md-6">
            <div class="form-group">
              <label>Cargo o Función</label>
              <app-input
                  type="text"
                  v-model="inputs.function"
                  :required="true"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>¿Cuenta Activa?</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.is_active"
                :list="isActive"
              />
            </div>
          </div>
        </div>
        <div class="row" v-if="show">
          <div class="col-md-6">
            <div class="form-group">
              <label>¿Convenio?</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.is_agreement"
                :list="isAgreement"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        is_active: 0,
      },
      modalId: "modal-add-edit",
      scope: [
        { id: null, value: this.$t("select_option") },
        {
          id: "O",
          value: "Interno", //SAE original
        },
        {
          id: "E",
          value: "Externo",
        },
      ],
      typeInstitution: [
        { id: null, value: this.$t("select_option") },
        {
          id: "PU",
          value: "Publica",
        },
        {
          id: "PR",
          value: "Privada",
        },
      ],
      isActive: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      isAgreement: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      delayTimer: null,
      show: false,
      counter: "",
      provinceList: [],
      cantonList: [],
      accreditationActivityLists: [{ id: "", value: this.$t("select_option") }],
      uniqueUsername: true,
      uniqueEmail: true,
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
    nickname() {
      return this.selectedUrl ? true : false;
    },
    evaluatorType() {
      return [
        { id: null, value: this.$t("select_option") },
        ...this.$store.state.evaluatorReview.evaluatorType,
      ];
    },
    cantons() {
      return [
        { id: null, value: this.$t("select_option") },
        ...this.$store.state.common.cantons,
      ];
    },
    accreditationAreaList() {
      return [
        { id: "", value: "Selecciona una opción" },
        ...this.$store.state.accreditation.accAppOptions.accreditationAreas,
      ];
    },
    accreditationActivityList() {
      return [
        { id: "", value: "Selecciona una opción" },
        ...this.$store.state.accreditation.accAppOptions
          .accreditationActivities,
      ];
    },
  },
  watch: {
    "inputs.country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.country_id
      );
    },

    "inputs.province_id": function () {
      this.cantonList = this.$store.getters.getCantons(this.inputs.province_id);
    },

   "$store.state.common.countries": function () {
      if (this.inputs.i_country_id) {
        this.provinceList = this.$store.getters.getProvinces(
          this.inputs.i_country_id
        );
        this.cantonList = this.$store.getters.getCantons(
          this.inputs.org.i_province_id
        );
      }
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
      this.show = true;
    }
  },
  methods: {
    submit() {
      if (!this.uniqueUsername) {
        this.$toastr.e("Nombre de usuario registrado");
      }
      if (!this.uniqueEmail) {
        this.$toastr.e("Correo registrado");
      }
      this.inputs.address = "N/A";
      this.save(this.inputs);
    },

    afterSuccess(response) {
      // this.$toastr.s(response.data.message);
      if (this.selectedUrl != "") {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.preloader = false;
      const { data } = response;
      this.inputs = data;
      this.onChangeAccreditationArea();
    },

    onChangeAccreditationArea() {
      this.accreditationActivityLists = [
        { id: "", value: this.$t("select_option") },
        ...this.accreditationActivityList.filter((item) => {
          return item.parent == this.inputs.area_id;
        }),
      ];
    },

    onKeyUpTaxid() {
      this.counter = this.inputs.taxid.length;
      if (this.inputs.taxid.length == 10 || this.inputs.taxid.length == 13) {
        if (this.inputs.taxid != null && !this.inputs.id) {
          clearTimeout(this.delayTimer);
          this.delayTimer = setTimeout(this.ckeckTaxid, 1000);
        }
      }
    },

    handleBlur(e) {
      if (this.inputs.taxid != null && !this.inputs.id) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(this.ckeckTaxid, 1000);
      }
    },

    ckeckTaxid() {
      this.preloader = true;
      clearTimeout(this.delayTimer);
      const url = `/evaluator/maintenance/user?taxid=${this.inputs.taxid}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            const { data } = response;
            this.show = true;
            if (data) {
              const tmp = {
                user_id: data.id,
                first_name: data.first_name,
                last_name: data.last_name,
                phone: data.phone,
                email: data.email,
              };
              this.inputs = {
                ...this.inputs,
                ...tmp,
              };
            }
          }
        })
        .catch(({ error }) => {
          this.$toastr.e(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    onKeyUpUsername() {
      if (this.inputs.taxid != null && !this.inputs.id) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(this.ckeckUsername, 1000);
      }
    },
    ckeckUsername() {
      this.preloader = true;
      clearTimeout(this.delayTimer);
      const url = `/evaluator/maintenance/user?username=${this.inputs.username}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.uniqueUsername = response.data == "";
          }
        })
        .catch(({ error }) => {
          this.$toastr.e(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    onKeyUpEmail() {
      if (this.inputs.taxid != null && !this.inputs.id) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(this.ckeckEmail, 1000);
      }
    },
    ckeckEmail() {
      this.preloader = true;
      clearTimeout(this.delayTimer);
      const url = `/evaluator/maintenance/user?email=${this.inputs.email}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.uniqueEmail = response.data == "";
          }
        })
        .catch(({ error }) => {
          this.$toastr.e(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
